(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["atelier-room-preview"] && !Shopify.designMode) return;
  try {
    
  class AtelierRoomPreview {
    constructor(root) {
      this.root = root;
      this.dialog = root.querySelector('[data-room-preview-dialog]');
      this.file = root.querySelector('[data-room-preview-file]');
      this.stage = root.querySelector('[data-room-preview-stage]');
      this.room = root.querySelector('[data-room-preview-room]');
      this.source = root.querySelector('[data-room-preview-source]');
      this.product = root.querySelector('[data-room-preview-product]');
      this.empty = root.querySelector('[data-room-preview-empty]');
      this.adjust = root.querySelector('[data-room-preview-adjust]');
      this.scaleInput = root.querySelector('[data-room-preview-scale]');
      this.download = root.querySelector('[data-room-preview-download]');
      this.error = root.querySelector('[data-room-preview-error]');
      this.arButtons = Array.from(root.querySelectorAll('[data-room-preview-ar]'));
      this.summaryPrice = root.querySelector('[data-room-preview-price]');
      this.variantPrices = root.querySelector('[data-room-preview-variant-prices]');
      this.position = { x: 0, y: 0, scale: 1 };
      this.drag = null;
      this.roomObjectUrl = null;
      this.bind();
      this.updateArButton(root.dataset.initialVariantTitle);
      this.applyProductTransform();
      this.prepareProduct();
    }

    bind() {
      this.root.querySelector('[data-room-preview-open]').addEventListener('click', () => {
        this.track('opened');
        this.dialog.showModal();
      });
      this.root.querySelector('[data-room-preview-close]').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.dialog.close();
      });
      this.file.addEventListener('change', () => this.loadFile(this.file.files[0]));
      this.empty.addEventListener('click', () => this.file.click());
      this.stage.addEventListener('dragover', (event) => event.preventDefault());
      this.stage.addEventListener('drop', (event) => {
        event.preventDefault();
        this.loadFile(event.dataTransfer.files[0]);
      });
      this.product.addEventListener('pointerdown', (event) => this.startDrag(event));
      window.addEventListener('pointermove', (event) => this.moveDrag(event));
      window.addEventListener('pointerup', () => { this.drag = null; });
      this.scaleInput.addEventListener('input', () => {
        this.position.scale = Number(this.scaleInput.value) / 100;
        this.applyProductTransform();
      });
      this.root.querySelector('[data-room-preview-reset]').addEventListener('click', () => this.reset());
      if (this.download) this.download.addEventListener('click', () => this.downloadPreview());
      this.root.querySelector('[data-room-preview-continue]').addEventListener('click', () => this.continueShopping());
      this.arButtons.forEach((button) => {
        button.addEventListener('click', () => this.track('ar_opened'));
      });
      document.addEventListener('change', (event) => {
        if (!event.target.closest('.variant-selects-main')) return;
        window.setTimeout(() => this.updateArButton(event.target.value), 100);
      });
      const variantInput = document.querySelector('[id^="update-variant-"]');
      const productSectionId = variantInput?.id.replace('update-variant-', '');
      if (productSectionId) {
        document.addEventListener(`eurus:product-page-variant-select:updated:${productSectionId}`, (event) => {
          const selectedVariant = event.detail.html.querySelector('.variant-selects-main [data-selected-variant]');
          if (!selectedVariant) return;
          try {
            this.updateSelectedVariant(JSON.parse(selectedVariant.textContent));
          } catch (error) {
            console.warn('Room visualizer could not read the selected variant.', error);
          }
        });
      }
    }

    updateSelectedVariant(variant) {
      if (!variant) return;
      this.updateArButton(variant.title);
      const prices = Array.from(this.variantPrices?.content.querySelectorAll('[data-variant-id]') || []);
      const selectedPrice = prices.find((price) => price.dataset.variantId === String(variant.id));
      if (this.summaryPrice && selectedPrice) this.summaryPrice.textContent = selectedPrice.textContent;
    }

    updateArButton(variantTitle) {
      if (!this.arButtons.length) return;
      if (this.arButtons.length === 1) {
        this.arButtons[0].hidden = false;
        return;
      }
      const normalizedTitle = String(variantTitle || '').replace(/\s+/g, ' ').trim();
      let matched = false;
      this.arButtons.forEach((button) => {
        const buttonTitle = String(button.dataset.arVariantTitle || '').replace(/\s+/g, ' ').trim();
        const selected = buttonTitle === normalizedTitle;
        button.hidden = !selected;
        if (selected) matched = true;
      });
      if (!matched) this.arButtons[0].hidden = false;
    }

    prepareProduct() {
      const render = () => {
        const cropMode = this.root.dataset.cropMode || 'none';
        const sourceWidth = this.source.naturalWidth;
        const sourceHeight = this.source.naturalHeight;
        if (!sourceWidth || !sourceHeight) return;

        let cropX = 0;
        let cropWidth = sourceWidth;
        if (cropMode.endsWith('_third')) {
          cropWidth = Math.floor(sourceWidth / 3);
          if (cropMode === 'center_third') cropX = cropWidth;
          if (cropMode === 'right_third') cropX = cropWidth * 2;
        }

        const outputScale = Math.min(1, 1200 / sourceHeight);
        this.product.width = Math.max(1, Math.round(cropWidth * outputScale));
        this.product.height = Math.max(1, Math.round(sourceHeight * outputScale));
        const context = this.product.getContext('2d', { willReadFrequently: true });
        context.clearRect(0, 0, this.product.width, this.product.height);
        context.drawImage(
          this.source,
          cropX,
          0,
          cropWidth,
          sourceHeight,
          0,
          0,
          this.product.width,
          this.product.height
        );

        const backgroundRemoved = this.root.dataset.removeBackground === 'true'
          ? this.removeConnectedBackground(context)
          : false;
        this.product.style.mixBlendMode = backgroundRemoved ? 'normal' : (this.root.dataset.blendMode || 'normal');
      };

      this.source.addEventListener('load', render);
      if (this.source.complete) render();
    }

    removeConnectedBackground(context) {
      try {
        const width = this.product.width;
        const height = this.product.height;
        const image = context.getImageData(0, 0, width, height);
        const pixels = image.data;
        const sampleSize = Math.max(3, Math.min(12, Math.floor(Math.min(width, height) / 20)));
        const corners = [[0, 0], [width - sampleSize, 0], [0, height - sampleSize], [width - sampleSize, height - sampleSize]];
        const reference = [0, 0, 0];
        let samples = 0;

        corners.forEach(([startX, startY]) => {
          for (let y = startY; y < startY + sampleSize; y += 1) {
            for (let x = startX; x < startX + sampleSize; x += 1) {
              const offset = (y * width + x) * 4;
              reference[0] += pixels[offset];
              reference[1] += pixels[offset + 1];
              reference[2] += pixels[offset + 2];
              samples += 1;
            }
          }
        });
        reference[0] /= samples;
        reference[1] /= samples;
        reference[2] /= samples;

        const visited = new Uint8Array(width * height);
        const queue = new Int32Array(width * height);
        let head = 0;
        let tail = 0;
        const thresholdSquared = 12 * 12;
        const enqueue = (x, y) => {
          if (x < 0 || y < 0 || x >= width || y >= height) return;
          const index = y * width + x;
          if (visited[index]) return;
          visited[index] = 1;
          const offset = index * 4;
          const red = pixels[offset] - reference[0];
          const green = pixels[offset + 1] - reference[1];
          const blue = pixels[offset + 2] - reference[2];
          if ((red * red) + (green * green) + (blue * blue) <= thresholdSquared) {
            queue[tail] = index;
            tail += 1;
          }
        };

        for (let x = 0; x < width; x += 1) {
          enqueue(x, 0);
          enqueue(x, height - 1);
        }
        for (let y = 0; y < height; y += 1) {
          enqueue(0, y);
          enqueue(width - 1, y);
        }

        while (head < tail) {
          const index = queue[head];
          head += 1;
          pixels[(index * 4) + 3] = 0;
          const x = index % width;
          const y = Math.floor(index / width);
          enqueue(x - 1, y);
          enqueue(x + 1, y);
          enqueue(x, y - 1);
          enqueue(x, y + 1);
        }

        const cleanupStart = Math.floor(height * 0.88);
        for (let y = cleanupStart; y < height; y += 1) {
          for (let x = 0; x < width; x += 1) {
            const offset = (y * width + x) * 4;
            if (pixels[offset + 3] === 0) continue;
            const red = pixels[offset];
            const green = pixels[offset + 1];
            const blue = pixels[offset + 2];
            const brightest = Math.max(red, green, blue);
            const darkest = Math.min(red, green, blue);
            if (brightest - darkest < 55 && (red + green + blue) / 3 > 130) {
              pixels[offset + 3] = 0;
            }
          }
        }

        context.putImageData(image, 0, 0);
        return true;
      } catch (error) {
        return false;
      }
    }

    loadFile(file) {
      this.showError('');
      if (!file) return;
      if (!['image/jpeg', 'image/png', 'image/webp'].includes(file.type)) {
        this.showError('unsupported');
        return;
      }
      if (file.size > 15 * 1024 * 1024) {
        this.showError('too_large');
        return;
      }
      if (this.roomObjectUrl) URL.revokeObjectURL(this.roomObjectUrl);
      this.roomObjectUrl = URL.createObjectURL(file);
      this.room.onload = () => {
        this.empty.hidden = true;
        this.room.hidden = false;
        this.product.hidden = false;
        this.adjust.hidden = false;
        if (this.download) this.download.disabled = false;
        this.reset();
        this.track('photo_loaded');
      };
      this.room.src = this.roomObjectUrl;
    }

    showError(type) {
      if (!type) {
        this.error.hidden = true;
        return;
      }
      const key = type === 'too_large' ? 'data-error-too-large' : 'data-error-unsupported';
      this.error.textContent = this.root.getAttribute(key) || '';
      this.error.hidden = false;
    }

    startDrag(event) {
      event.preventDefault();
      this.product.setPointerCapture?.(event.pointerId);
      this.drag = { x: event.clientX, y: event.clientY, originX: this.position.x, originY: this.position.y };
    }

    moveDrag(event) {
      if (!this.drag) return;
      this.position.x = this.drag.originX + event.clientX - this.drag.x;
      this.position.y = this.drag.originY + event.clientY - this.drag.y;
      this.applyProductTransform();
    }

    applyProductTransform() {
      this.product.style.transform = `translate(-50%, -50%) translate(${this.position.x}px, ${this.position.y}px) scale(${this.position.scale})`;
    }

    reset() {
      this.position = { x: 0, y: 0, scale: 1 };
      this.scaleInput.value = 100;
      this.applyProductTransform();
    }

    async downloadPreview() {
      try {
        const canvas = document.createElement('canvas');
        canvas.width = this.room.naturalWidth;
        canvas.height = this.room.naturalHeight;
        const context = canvas.getContext('2d');
        context.drawImage(this.room, 0, 0, canvas.width, canvas.height);

        const stageRect = this.stage.getBoundingClientRect();
        const roomRect = this.room.getBoundingClientRect();
        const productRect = this.product.getBoundingClientRect();
        const ratioX = canvas.width / roomRect.width;
        const ratioY = canvas.height / roomRect.height;
        const roomOffsetX = roomRect.left - stageRect.left;
        const roomOffsetY = roomRect.top - stageRect.top;
        const drawX = (productRect.left - stageRect.left - roomOffsetX) * ratioX;
        const drawY = (productRect.top - stageRect.top - roomOffsetY) * ratioY;
        const drawWidth = productRect.width * ratioX;
        const drawHeight = productRect.height * ratioY;
        context.globalCompositeOperation = this.root.dataset.blendMode === 'multiply' ? 'multiply' : 'source-over';
        context.drawImage(this.product, drawX, drawY, drawWidth, drawHeight);
        context.globalCompositeOperation = 'source-over';

        const link = document.createElement('a');
        link.download = `${this.root.dataset.productTitle || 'atelier-orna'}-room-preview.jpg`;
        link.href = canvas.toDataURL('image/jpeg', 0.92);
        link.click();
        this.track('downloaded');
      } catch (error) {
        this.showError('unsupported');
      }
    }

    continueShopping() {
      this.dialog.close();
      const productForm = document.querySelector('form[action*="/cart/add"]');
      const target = productForm || document.querySelector('[name="add"]');
      target?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      target?.querySelector?.('[type="submit"]')?.focus();
      this.track('continued_to_purchase');
    }

    track(action) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'atelier_room_preview', action, product: this.root.dataset.productTitle });
    }
  }

  document.querySelectorAll('[data-room-preview]').forEach((root) => {
    if (!root.dataset.initialized) {
      root.dataset.initialized = 'true';
      new AtelierRoomPreview(root);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atelierorna-campaign-announcement"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = (root = document) => {
    root.querySelectorAll('[data-ao-campaign-bar]').forEach((bar) => {
      if (bar.dataset.countdownReady === 'true') return;

      const deadline = Date.parse(bar.dataset.deadline);
      if (Number.isNaN(deadline)) return;

      bar.dataset.countdownReady = 'true';
      const countdown = bar.querySelector('[data-ao-countdown]');

      const fields = {
        days: bar.querySelector('[data-ao-days]'),
        hours: bar.querySelector('[data-ao-hours]'),
        minutes: bar.querySelector('[data-ao-minutes]'),
        seconds: bar.querySelector('[data-ao-seconds]')
      };

      let timer;

      const update = () => {
        const remaining = deadline - Date.now();
        if (remaining <= 0) {
          if (countdown) countdown.hidden = true;
          if (timer) clearInterval(timer);
          return;
        }
        const days = Math.floor(remaining / 86400000);
        const hours = Math.floor((remaining % 86400000) / 3600000);
        const minutes = Math.floor((remaining % 3600000) / 60000);
        const seconds = Math.floor((remaining % 60000) / 1000);

        fields.days.textContent = String(days).padStart(2, '0');
        fields.hours.textContent = String(hours).padStart(2, '0');
        fields.minutes.textContent = String(minutes).padStart(2, '0');
        fields.seconds.textContent = String(seconds).padStart(2, '0');
        if (countdown) countdown.hidden = false;
      };

      update();
      timer = window.setInterval(update, 1000);
    });
  };

  initialize();

  document.addEventListener('shopify:section:load', (event) => {
    initialize(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
